<app-header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="page-content" *ngIf="!isActivated">
    <div class="section s1 w-in-p">{{getString('workInProgress')}}</div>
</div>

<div class="page-content" *ngIf="isActivated && referralData">

    <div class="section s1">

        <h1 class="s1-title">{{getString('referralsPageTitle')}}</h1>
        <div class="s1-text bigger-text">{{getString('referralsPageText')}}</div>

        <div class="box">
            <div class="bold label">{{getString('pointsPerReferral')}}</div>
            <div *ngIf="referralData.user.specialOfferRunning" class="green-text bigger-text">{{getString('specialOfferUntil')}} {{referralData.user.specialOfferEndDate}}</div>
            <div class="bigger-text">{{getString('forEveryReferredUser')}}
                <span *ngIf="referralData.user.specialOfferRunning">
                    <span class="strike">{{referralData.user.earningValue}} {{getString('points')}}</span> <span class="green-text"> {{referralData.user.specialOfferEarningValue}} {{getString('points')}}</span>.
                </span>
                <span *ngIf="!referralData.user.specialOfferRunning">
                    {{referralData.user.earningValue}} {{getString('points')}}.
                </span>
            </div>
        </div>

        <div class="box">
            <div class="bold label">{{getString('inviteYourFriendsByMail')}}</div>
            <input type="email" [class.invalid]="invalidInviteEmail" [placeholder]="getString('yourFriendsEmailAddress')" [(ngModel)]="inviteEmail" (keyup)="invalidInviteEmail = false">
            <button type="button" class="blue-button" (click)="sendInvitation()">{{getString('sendInvitation')}}</button>
        </div>

        <div class="box">
            <div class="bold label">{{getString('shareYourInvitationLink')}}</div>
            
            <div class="cp-tooltip" (mouseout)="linkOut()">
                <input id="shareLinkInput" type="text" [value]="referralData.user.referralUrl" (focus)="selectInput($event)" readonly>
                <span class="cp-tooltiptext" id="myCPTooltip">{{getString('copyToClipboard')}}</span>
            </div>
            <img class="share-icon" src="./assets/images/link_purple.png" alt="share link" (mouseenter)="shareIconMouseEnter()" (mouseleave)="shareIconMouseLeave()" (click)="shareIconClick()">

            <a [href]="facebookShareURL()" target="_blank" rel="nofollow" (click)="shareClick('Facebook')"><img class="share-icon" src="./assets/images/facebook_share.png" alt="facebook share"></a>
            <a [href]="twitterShareURL()" target="_blank" rel="nofollow" (click)="shareClick('Twitter')"><img class="share-icon" src="./assets/images/twitter_share.png" alt="twitter share"></a>
            <a [href]="emailShareURL()" target="_blank" rel="nofollow" (click)="shareClick('Email')"><img class="share-icon" src="./assets/images/mail_share.png" alt="mail share"></a>
        </div>

    </div>
    <div class="section s2">
        <div class="card">
            <img class="piggie" src="./assets/images/pig_blue.png">
            <div class="big-text">{{getString('yourPoints')}}</div>
            <div class="points">{{referralData.user.points}}</div>
            <a [href]="getRedeemUrl()"><button type="button" class="blue-button">{{getString('redeemGiftCard')}}</button></a>
        </div>
        <div>
            <span class="bold unselectable">{{getString('yourReferralCode')}}</span> <span class="code">{{referralData.user.referralCode}}</span>
        </div>
    </div>
    <div class="section s3" *ngIf="referralData.referrals">
        <div class="bold label">{{getString('yourInvitationsSoFar')}}</div>
        <table class="desktop">
            <thead>
               <tr>
                    <th>{{getString('invitationDate')}}</th>
                    <th>{{getString('referredAddress')}}</th>
                    <th>{{getString('pointsEarned')}}</th>
                    <th class="tooltip-b">{{getString('status')}} <img class="icon info" src="./assets/images/info_icon.png">
                        <div class="tooltiptext-b">
                            <div class="icon-legend"><img class="icon" src="./assets/images/checkmark_grey.png">{{getString("waiting")}}</div>
                            <div class="icon-legend"><img class="icon" src="./assets/images/checkmark_yellow.png">{{getString("signedUp")}}</div>
                            <div class="icon-legend"><img class="icon" src="./assets/images/checkmark_green.png">{{getString("successfullyReferred")}}</div>
                        </div>
                    </th>
                    <th>{{getString('action')}}</th>
               </tr> 
            </thead>
            <tbody>
                <tr *ngFor="let referral of referralData.referrals">
                    <td>{{getFormattedDate(referral.dateCreated)}}</td>
                    <td>{{referral.referredUserMail ? referral.referredUserMail : referral.referredUserUser ? referral.referredUserUser.email : ""}}</td>
                    <td>{{referral.pointsEearned}}</td>
                    <td *ngIf="referral.referralStatus == 'WAITING_FOR_SIGNING_UP'"><img class="icon" src="./assets/images/checkmark_grey.png">{{getString("waiting")}}</td>
                    <td *ngIf="referral.referralStatus == 'SIGNED_UP'"><img class="icon" src="./assets/images/checkmark_yellow.png">{{getString("signedUp")}}</td>
                    <td *ngIf="referral.referralStatus == 'SUCESSFULLY_CONVERTED'"><img class="icon" src="./assets/images/checkmark_green.png">{{getString("successfullyReferred")}}</td>
                    <td>
                        <span class="action" [class.action-disabled]="referral.referralStatus == 'WAITING_FOR_SIGNING_UP'" (click)="resendInvitation(referral)">{{getString('resend')}}</span>
                        <span class="action" (click)="removeInvitation(referral)">{{getString('remove')}}</span>
                    </td>
                </tr>
            </tbody>
        </table>
        <table class="card mobile" *ngFor="let referral of referralData.referrals">
            <tr>
                <th>{{getString('invitationDate')}}</th>
                <td>{{getFormattedDate(referral.dateCreated)}}</td>
            </tr>
            <tr>
                <th>{{getString('referredAddress')}}</th>
                <td>{{referral.referredUserMail ? referral.referredUserMail : referral.referredUserUser ? referral.referredUserUser.email : ""}}</td>
            </tr>
            <tr>
                <th>{{getString('pointsEarned')}}</th>
                <td>{{referral.pointsEearned}}</td>
            </tr>
            <tr>
                <th>{{getString('status')}} <img class="icon info" src="./assets/images/info_icon.png"></th>
                <td *ngIf="referral.referralStatus == 'WAITING_FOR_SIGNING_UP'"><img class="icon" src="./assets/images/checkmark_grey.png">{{getString("waiting")}}</td>
                    <td *ngIf="referral.referralStatus == 'SIGNED_UP'"><img class="icon" src="./assets/images/checkmark_yellow.png">{{getString("signedUp")}}</td>
                    <td *ngIf="referral.referralStatus == 'REFERRED'"><img class="icon" src="./assets/images/checkmark_green.png">{{getString("successfullyReferred")}}</td>
            </tr>
            <tr>
                <th>{{getString('action')}}</th>
                <td>
                    <span class="action" [class.action-disabled]="referral.referralStatus == 'WAITING_FOR_SIGNING_UP'" (click)="resendInvitation(referral)">{{getString('resend')}}</span>
                </td>
            </tr>
        </table>
    </div>
    <div class="section s4">
        <h2>{{getString('howDoesItWork')}}</h2>
        <div class="third">
            <img class="s4-icon" src="./assets/images/link_purple.png">
            <h3>{{getString('shareYourLink')}}</h3>
            <div>{{getString('shareYouLinkText')}}</div>
        </div>
        <div class="third">
            <img class="s4-icon" src="./assets/images/cart_purple.png">
            <h3>{{getString('makeThemBuyiTunesDeals')}}</h3>
            <div>{{getString('makeThemBuyiTunesDealsText')}}</div>
        </div>
        <div class="third">
            <img class="s4-icon" src="./assets/images/pig_purple.png">
            <h3>{{getString('youllEarn')}}</h3>
            <div>{{getString('youllEarnText')}}</div>
        </div>
    </div>

</div>
<div>
    <app-home-footer></app-home-footer>
</div>

<app-authentication #authentication></app-authentication>